import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

export function CreateTermineSubmitButton() {
  const { t } = useTranslation();
  const { loading, onSubmit, isMobile } = useCreateTermineFormContext();

  const buttonContent = loading ? (
    <>
      <FontAwesomeIcon icon={faSpinnerThird} spin />
      {t('actions.loading')}
    </>
  ) : (
    t('domain.termine.form.fertig')
  );

  return isMobile ? (
    <Button
      variant="ghost-primary"
      type="button"
      onClick={onSubmit}
      size="sm"
      disabled={loading}
      className="gap-2">
      {buttonContent}
    </Button>
  ) : (
    <Button
      variant="default"
      type="button"
      onClick={onSubmit}
      disabled={loading}
      className="gap-2">
      {buttonContent}
    </Button>
  );
}
